document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('[data-custom-sort-client]');
  if (!wrapper) return;

  const trigger = wrapper.querySelector('.custom-sort-trigger');
  const items = wrapper.querySelectorAll('.custom-sort-item');
  const grid = wrapper.closest('.shopify-section').querySelector('.grid.grid--uniform, .grid');

  trigger.addEventListener('click', function () {
    wrapper.classList.toggle('is-open');
  });

  document.addEventListener('click', function (e) {
    if (!wrapper.contains(e.target)) wrapper.classList.remove('is-open');
  });

  items.forEach(function (item) {
    item.addEventListener('click', function () {
      const sortType = item.dataset.sort;
      const cards = Array.from(grid.children);

      cards.sort(function (a, b) {
        switch (sortType) {
          case 'title-ascending':
            return a.dataset.title.localeCompare(b.dataset.title);
          case 'title-descending':
            return b.dataset.title.localeCompare(a.dataset.title);
          case 'price-ascending':
            return Number(a.dataset.price) - Number(b.dataset.price);
          case 'price-descending':
            return Number(b.dataset.price) - Number(a.dataset.price);
          case 'created-ascending':
            return Number(a.dataset.created) - Number(b.dataset.created);
          case 'created-descending':
            return Number(b.dataset.created) - Number(a.dataset.created);
          default:
            return 0;
        }
      });

      cards.forEach(function (card) { grid.appendChild(card); });
      wrapper.classList.remove('is-open');
    });
  });
});